module.exports = __webpack_public_path__ + "static/img/Smart_Blend.78631ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Smart_Blend.jpg
// module id = lh07
// module chunks = 1